export default "__VITE_ASSET__221d4f49__"